/**
 * Trial switch: the Calendar / Workload layouts on the Tasks page (ToDo.vue, redesigned branch).
 * 'list' unless a Super Admin picked another layout in this browser (localStorage `teamio_tasks_layout`
 * = 'calendar' | 'workload'). Picking 'list' clears the key. Absent / unknown / non-Super-Admin ⇒ 'list',
 * always. Import-free (the node-tests execute this file).
 */

export const TASKS_LAYOUT_KEY = 'teamio_tasks_layout';
const PICKABLE = ['calendar', 'workload'];

export function tasksLayout({ isSuperAdmin, storage } = {}) {
  if (isSuperAdmin !== true) return 'list';
  try {
    const v = storage && typeof storage.getItem === 'function' ? storage.getItem(TASKS_LAYOUT_KEY) : null;
    return PICKABLE.indexOf(v) > -1 ? v : 'list';
  } catch (e) {
    return 'list';
  }
}

/** The sidebar views (myDay.js VIEW_KEYS — pinned equal by cypress/node-tests/tasks-calendar-view.test.js). */
export const VIEW_KEYS = ['myDay', 'assignedToMe', 'createdByMe', 'upcoming', 'everyone', 'completedToday'];

/** Views that are not about the signed-in user: under Calendar / Workload they all mean "everyone". */
export const OFFICE_WIDE_VIEWS = ['myDay', 'upcoming', 'everyone', 'completedToday'];

/** The view the sidebar highlights and the calendar scopes by: office-wide views read as 'everyone' outside the list. */
export function layoutView(layout, view) {
  return layout !== 'list' && OFFICE_WIDE_VIEWS.indexOf(view) > -1 ? 'everyone' : view;
}

/**
 * What a Tasks route asks for — `?layout=calendar|workload|list`, `?view=<key>`, `?compose=1` — from the
 * Ctrl+K palette's commands. Anything unknown is ignored (null / false). A layout reaches ONLY a Super Admin.
 * `?screen=reports` is the page's own and is not read here.
 */
export function routeIntent(query, { isSuperAdmin } = {}) {
  const q = query && typeof query === 'object' ? query : {};
  const one = v => (Array.isArray(v) ? v[0] : v);
  const layout = one(q.layout);
  const view = one(q.view);
  const compose = one(q.compose);
  return {
    layout: isSuperAdmin === true && (layout === 'list' || PICKABLE.indexOf(layout) > -1) ? layout : null,
    view: VIEW_KEYS.indexOf(view) > -1 ? view : null,
    compose: compose === '1' || compose === 'true',
  };
}

/** 'calendar' / 'workload' store it, 'list' clears the key. Returns false for anything else or a refusing storage. */
export function setTasksLayout(storage, layout) {
  if (layout !== 'list' && PICKABLE.indexOf(layout) === -1) return false;
  try {
    if (!storage) return false;
    if (layout === 'list') storage.removeItem(TASKS_LAYOUT_KEY);
    else storage.setItem(TASKS_LAYOUT_KEY, layout);
    return true;
  } catch (e) {
    return false;
  }
}
